import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "./../store";
export interface SensorData {
  selectedSensor: any;
}
const storedSensor = localStorage.getItem("selectedSensor");
const initialState: SensorData = {
  selectedSensor: storedSensor ? JSON.parse(storedSensor) : null,
};

const sensorSlice = createSlice({
  name: "sensor",
  initialState,
  reducers: {
    setCurrentSensor: (state, action: PayloadAction<any>) => {
      state.selectedSensor = action.payload;
      localStorage.setItem("selectedSensor", JSON.stringify(action.payload));
    },
  },
});
export const { setCurrentSensor } = sensorSlice.actions;
export default sensorSlice.reducer;
export const currentSensor = (state: RootState) => state.sensor.selectedSensor;
